// src/components/Home/Home.js
import React, { useState, useEffect } from 'react';

import HeroSection from "./Home/HeroSection";
import ServiceSection from "./Home/ServiceSection";
import Testimonials from "./Home/Testimonials"
import CTASection from "./Home/CTASection";
import StatSection from "./Home/StatSection";
import BookConsultationSection from "./Home/BookConsultationSection";
import AboutSection from "./Home/AboutSection";
import WhySection from "./Home/WhySection";
import PartnerSection from "./Home/PartnerSection";
import Contact from "./Home/Contact";

import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from "./Header"
import Footer from "./Footer"

const Home = () => {

    // inside your component
    useEffect(() => {
        AOS.init({ once: true }); // or any config you like
    }, []);

    return (
        <main>
            <Header />
            <HeroSection />
            <ServiceSection />
            <Testimonials />
            <StatSection />
            <AboutSection />
            <BookConsultationSection />
            <CTASection />
            <WhySection />
            <PartnerSection />
            <Contact />
            <Footer />
            {/* Add more sections as needed */}
        </main>
    );
};

export default Home;
